module.exports = __webpack_public_path__ + "img/lz1.b26e4424.png";